module.exports = "images/4ans.a61069f8.png";